module.exports = __webpack_public_path__ + "static/img/tuijian2.fa43ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tuijian2.jpg
// module id = 0Ahc
// module chunks = 1